import { PERF_PROBE_LEVEL, type PerfProbeLevel } from '../types'

export const HIGH_FRAME_THRESHOLD = 500
export const MEDIUM_FRAME_THRESHOLD = 50

const LEVEL_RANK: Record<PerfProbeLevel, number> = {
  [PERF_PROBE_LEVEL.Low]: 0,
  [PERF_PROBE_LEVEL.Medium]: 1,
  [PERF_PROBE_LEVEL.High]: 2,
}

export function resolvePerfProbeLevel(frames: number): PerfProbeLevel {
  if (frames >= HIGH_FRAME_THRESHOLD) return PERF_PROBE_LEVEL.High
  if (frames >= MEDIUM_FRAME_THRESHOLD) return PERF_PROBE_LEVEL.Medium
  return PERF_PROBE_LEVEL.Low
}

export function capPerfProbeLevel(
  current: PerfProbeLevel,
  maximum: PerfProbeLevel,
): PerfProbeLevel {
  return LEVEL_RANK[current] > LEVEL_RANK[maximum] ? maximum : current
}
